import {connect} from '../../app/connect';
import IssuePreviewActivityContent from './IssuePreviewActivityContent';

import {
  getAllOxygenMappings,
  getCurrentUserInMcFormat,
  getAccessToken,
  getAllProjectEntities,
  doesIssueHavePreviousActivities,
  getCurrentViewType,
  getFieldIssueTypesAndSubTypesIdToTitleMap,
  getThumbnails,
  getIssueAttributesDefinitionsEntitiesMap,
  getIssueRootCausesDefinitionsEntitiesMap,
  getCurrentPreviewIssueId,
  getActivityDummyBlock,
  getEntityUserNameGetter,
  getDocumentCollection
} from '../../app/selectors';

import {showAttachmentsInGallery, fieldIssuesActivityFetchAttachments, loadMoreActivities} from '../../app/actions';

const mapStateToProps = state => ({
  issueId: getCurrentPreviewIssueId(state),
  oxygen: getAllOxygenMappings(state),
  rootCauseEntitiesMap: getIssueRootCausesDefinitionsEntitiesMap(state),
  issueTypesAndSubTypesTitleMap: getFieldIssueTypesAndSubTypesIdToTitleMap(state),
  currentUser: getCurrentUserInMcFormat(state),
  accessToken: getAccessToken(state).token,
  projectEntities: getAllProjectEntities(state),
  hasPreviousActivities: doesIssueHavePreviousActivities(state),
  viewType: getCurrentViewType(state),
  thumbnailsByUrn: getThumbnails(state),
  issueCustomAttributes: getIssueAttributesDefinitionsEntitiesMap(state),
  dummyActivityBlock: getActivityDummyBlock(state),
  getEntityDisplayNameById: getEntityUserNameGetter(state),
  documentCollection: getDocumentCollection(state)
});

const mapDispatchToProps = {
  showAttachmentsInGallery,
  fieldIssuesActivityFetchAttachments,
  loadMoreActivities
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssuePreviewActivityContent);
